import { createContext, useContext } from "react"

import { getInitialState } from "./useKai.reducer"

import type { TKaiContext } from "./useKai.types"

export const KaiContext = createContext<TKaiContext>({
  toggle: () => {},
  updateDrawerState: () => {},
  closeDrawer: () => {},
  setDirtyContext: () => {},
  ...getInitialState()
})

export const useKai = () => {
  const context = useContext(KaiContext)

  return context
}
